import React from 'react';
import { UserCircle, Moon, Sun } from 'lucide-react';
import { Session } from '@supabase/supabase-js';
import { UserMenu } from '@/components/UserMenu';

interface NavbarProps {
    session: Session | null;
    onAuthOpen: () => void;
    theme: 'light' | 'dark';
    toggleTheme: () => void;
    isMobile: boolean;
}

export const Navbar: React.FC<NavbarProps> = ({ session, onAuthOpen, theme, toggleTheme, isMobile }) => {
    return (
        <nav className="top-0 w-full z-50 px-6 py-6">
            <div className="max-w-5xl mx-auto flex items-center justify-between">
                <div className="flex items-center gap-3 glass-card px-4 py-2 mr-1 rounded-2xl border border-white/20 dark:border-white/5 shadow-lg shadow-black/5">
                    <div className="relative">
                        <div className="absolute inset-0 bg-blue-200 blur-lg opacity-50"></div>
                        <img
                            src="/logo.png"
                            alt="Logo"
                            className="relative w-8 h-8 object-contain"
                        />
                    </div>
                    <span className="font-bold text-sm sm:text-lg tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-600 dark:from-white dark:to-gray-400">
                        Radar da
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 dark:from-blue-400 dark:via-indigo-400 dark:to-purple-400 animate-gradient"> Economia</span>
                    </span>
                </div>

                <div className="flex items-center gap-1">
                    {session ? (
                        <UserMenu session={session} isMobile={isMobile} />
                    ) : (
                        <button
                            onClick={onAuthOpen}
                            className="flex items-center gap-2 px-4 py-2 rounded-full glass-card hover:bg-white/50 dark:hover:bg-gray-800/50 border border-white/20 dark:border-white/5 transition-all text-sm font-bold text-gray-700 dark:text-gray-200 shadow-sm"
                        >
                            <UserCircle className="w-5 h-5" />
                            <span className="hidden sm:inline">Entrar</span>
                        </button>
                    )}

                    <button
                        onClick={toggleTheme}
                        className="glass-card p-3 rounded-full hover:bg-white/50 dark:hover:bg-gray-800/50 transition-all active:scale-95 border border-white/20 dark:border-white/5"
                        aria-label="Alternar tema"
                    >
                        {theme === 'light' ? <Moon className="w-5 h-5 text-gray-600" /> : <Sun className="w-5 h-5 text-yellow-400" />}
                    </button>
                </div>
            </div>
        </nav>
    );
};
